import logo from './logo.svg';
import './App.css';

import { Layout, Space } from 'antd';
import HeaderContainer from './components/HeaderContainer';
import MapContainer from './components/MapContainer';
import NewMapContainer from './components/NewMapContainer';
import SideContainer from './components/SideContainer';
import React, { useState } from 'react';
import Map, { Source, Layer, Popup } from 'react-map-gl';

const { Header, Footer, Sider, Content } = Layout;

const headerStyle: React.CSSProperties = {
  color: '#fff',
  height: 64,
  paddingInline: 20,
  lineHeight: '64px',
  backgroundColor: '#3a3a3a00',
  position:'absolute',
  width: '500px',
  right: 'calc(50% - 250px)',

};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  minHeight: 65,
  lineHeight: '120px',
  color: '#fff',
  marginTop: '-65px',
  opacity: 1,
  backgroundColor: 'rgba(255,255,255, 0)'
  // position: 'absolute',
  // top: 50
};

const siderStyle: React.CSSProperties = {
  textAlign: 'center',
  lineHeight: '120px',
  color: '#fff',
  position: 'absolute',
  right: '0px',
  height: 'calc(100vh - 80px)',
  backgroundColor: '#00000000',
  pointerEvents: 'none'
};

const footerStyle: React.CSSProperties = {
  textAlign: 'right',
  color: 'gray',
  zIndex: 1001,
  boxShadow: '0px -2px 5px 0px #a3a3a3',
};

function App() {
  
  const [isMarker, setIsMarker] = useState(false);
  const [value, setValue] = useState('');
  const [state, setState] = useState({
    // crime: {
    //   on: false,
    //   progress: 100,
    //   property: true
    // },
    // race: {on: true, progress: 40}
    crime: {on: false, progress: 55, property: true},
    race: {on: false, progress: 55},
    voting: {on: true, progress: 55},
    ancestry: {on: false, progress: 35},
    occupancy: {on: false, progress: 55},
    income: {on: false, progress: 55},
    voting2024: {on: true, progress: 55},
  });
  const [region, setRegion] = useState(null);

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
      <Layout>
        <Header style={headerStyle}>
          <HeaderContainer
            setRegion={(region) => setRegion(region)}
            setValue={(val) => setValue(val)}
            setIsMarker={(marker) => {
              setIsMarker(marker)
            }}
            value={value}
          />
        </Header>
        <Layout>
          <Content style={contentStyle}>
            <NewMapContainer
              state={state}
              region={region}
              isMarker={isMarker}
              setValue={(val) => setValue(val)}
            />
          </Content>
          <Sider
            style={siderStyle}
            // className={slide ? '' : 'd-none'}
          >
            <SideContainer
              setState={(d) => setState(d)}
            />
          </Sider>
        </Layout>
      </Layout>
    </Space>
  );
}

export default App;
